import { LogoSvg } from "../utils/svg";
const Logo = ({ className }) => {
  return <LogoSvg className={className} />;
};

export default Logo;
